import { PixumEnvUtils } from '../pixumEnv';

/**
 * Detects if the code is running in a browser environment by checking for the existence of the `window` object.
 *
 * @returns True if running in a browser, false otherwise
 */
export function isBrowser() {
  return typeof window !== 'undefined';
}

/**
 * @deprecated - use isBrowser() from 'utils/lib/window/detection' instead
 */
export const hasWindowObject = typeof window !== 'undefined';

export const hasPixumEnv = isBrowser() && PixumEnvUtils.isInitialized();

export const isBrowserNavigator = typeof navigator !== 'undefined';
